/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useContext, useState } from 'react';
import { Form, FormGroup, Input, InputGroup, InputGroupAddon, Label, Button, Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalBody } from 'reactstrap';
import moment from 'moment';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext'

// import services
import AdminService from '../../services/AdminService';
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';

const Coupons = props => {

    // variables
    let timeout = 0;

    // states
    const [coupons, setCoupons] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [modal, setModal] = useState({ isVisible: false, data: { description: '', from: '', to: '', code: '', type: 'percentage', value: 0, qty: 0 } });
    const [pagination, setPagination] = useState({ limit: 10, page: 1 });
    const [description, setDescription] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    // contexts
    const { theme } = useContext(ThemeContext);

    // use Effects
    useEffect(() => {
        handleSearchSubmit(null);
    }, [pagination.page, pagination.limit]);

    // utility functions
    const generateCode = () => {
        try {
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            let CODE = '';
            for (let i = 0; i < 8; i++) {
                CODE += chars[Math.floor(Math.random() * 36)];
            }
            setModal({ ...modal, data: { ...modal.data, code: CODE } });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Coupons generateCode', 'Error in try catch block', err.stack);
        }
    }


    // handle functions
    const handleChange = e => {
        try {
            setModal({ ...modal, data: { ...modal.data, [e.target.name]: e.target.value } });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Coupons handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handlePagination = (e, index) => {
        e.preventDefault();
        try {
            setPagination({ ...pagination, page: index });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Coupons handlePagination', 'Error in try catch block', err.stack);
        }
    }

    const handleSearchSubmit = e => {
        if (e) e.preventDefault();
        try {
            if (!isLoading) {
                setIsLoading(true);
                AdminService.getCoupons(pagination.limit, pagination.page, description, fromDate, toDate).then(data => {
                    setCoupons(data.coupons);
                    if (data.pagination.totalPages <= data.pagination.page) {
                        data.pagination.page = data.pagination.totalPages;
                    }
                    setPagination(data.pagination);
                    setIsLoading(false);
                });
            }
        } catch (err) {
            setIsLoading(false);
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Admin Coupons handleSearchSubmit', 'Error in try catch block', err.stack);
        }
    }

    const handleCouponSubmit = e => {
        e.preventDefault();
        try {
            setIsLoading2(true);
            AdminService.addCoupons(modal.data).then(data => {
                setModal({ isVisible: false, data: { description: '', from: '', to: '', code: '', type: 'percentage', value: 0, qty: 0 } });
                handleSearchSubmit(e);
                Alert.info(data.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading2(false);
            }).catch(error => {
                Alert.error(error.message.msgBody, {
                    position: 'top-right',
                    effect: 'slide'
                });
                setIsLoading2(false);
            });
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            setIsLoading2(false);
            GeneralService.logError('at Admin Coupons handleCouponSubmit', 'Error in try catch block', err.stack);
        }
    }

    return (
        <main>
            <div className="container-fluid">
                <h3 className="my-4">Coupons</h3>
                <div className="card mb-4">
                    <div className="card-header d-flex">
                        <label className="my-auto">Coupon List</label>
                        <Button className="ml-auto my-auto px-3" type="button" style={Object.assign({ height: 'fit-content' }, theme.formButton)} onClick={() => setModal({ isVisible: true, data: { description: '', from: '', to: '', code: '', type: 'percentage', value: 0, qty: 0 } })}>Add</Button>
                    </div>
                    <div className="card-body py-0">
                        <div className="table-responsive">
                            <table className="table table-bordered mb-0" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <td colSpan="6" className="border-0 px-0">
                                            <Form inline className="d-flex" onSubmit={handleSearchSubmit}>
                                                <FormGroup className="mr-2">
                                                    <Label style={theme.formBodyText} className="mr-1">Description</Label>
                                                    <Input type="text" id="description" name="description" placeholder="Type here" value={description} onChange={(e) => setDescription(e.target.value)} className="form-control" style={Object.assign({ marginRight: "-20px", paddingRight: "20px" }, theme.formInput)} />
                                                    <span style={{ cursor: "pointer", marginRight: "7px", alignSelf: "center", zIndex: 100 }} onClick={() => { document.getElementById("description").value = ""; setPagination(""); }}><i className="fa fa-times"></i></span>
                                                </FormGroup>
                                                <FormGroup className="mr-2">
                                                    <Label style={theme.formBodyText} className="mr-1" >From</Label>
                                                    <Input type="date" id="fromDate" name="fromDate" value={fromDate} onChange={(e) => setFromDate(e.target.value)} className="form-control" style={theme.formInput} required />
                                                </FormGroup>
                                                <FormGroup className="mr-2">
                                                    <Label for="toDate" style={theme.formBodyText} className="mr-1" >To</Label>
                                                    <Input type="date" id="toDate" name="toDate" value={toDate} onChange={(e) => setToDate(e.target.value)} className="form-control" style={theme.formInput} required />
                                                </FormGroup>
                                                <Button type="submit" className="my-auto" style={Object.assign({ height: 'fit-content' }, theme.formButton)} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Search</Button>
                                                <Button type="button" className="ml-auto my-auto" style={Object.assign({ height: 'fit-content' }, theme.formButton)} onClick={handleSearchSubmit} disabled={isLoading}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Refresh</Button>
                                            </Form>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Code</th>
                                        <th>Value</th>
                                        <th>Description</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        coupons.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.code}</td>
                                                <td>{item.type === 'percentage' ? `${item.value}%` : `₹${item.value}`}</td>
                                                <td>{item.description}</td>
                                                <td>{moment(item.from).format('DD-MM-YYYY')}</td>
                                                <td>{moment(item.to).format('DD-MM-YYYY')}</td>
                                                <td>{item.qty}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan="6" className="border-0 pb-0">
                                            <div className="d-flex">
                                                {/* <div className="d-flex p-2">
                                                    <span>Showing {pagination.totalResults==0 ? 0 : 1 } to</span>
                                                    <Input style={{width:'47px', height: '30px', padding: '14px 5px', margin: '0 5px'}} id="limit" minLength="1" maxLength="4" name="limit" value={pagination.limit>pagination.totalResults ? pagination.totalResults : pagination.limit} onChange={e => handlePagination(e,null)} ></Input>
                                                    <span>of {pagination.totalResults} entries</span>
                                                </div> */}
                                                <ErrorBoundary errorAt="At Admin Coupons Pagination">
                                                    <div className="p-2">Showing {pagination.totalResults == 0 ? 0 : (1 + (10 * (pagination.page - 1)))} to {(pagination.limit + (10 * (pagination.page - 1))) > pagination.totalResults ? pagination.totalResults : (pagination.limit + (10 * (pagination.page - 1)))} of {pagination.totalResults} entries</div>
                                                    <Pagination aria-label="Page navigation example" className="ml-auto">
                                                        <PaginationItem disabled={pagination.page == 1}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page - 1)}
                                                                previous
                                                                href="#" />
                                                        </PaginationItem>
                                                        {[...Array(pagination.totalPages)].map((page, i) =>
                                                            <PaginationItem active={i + 1 === pagination.page} key={i}>
                                                                <PaginationLink onClick={e => handlePagination(e, i + 1)} href="#">
                                                                    {i + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        )}
                                                        <PaginationItem disabled={pagination.page == pagination.totalPages}>
                                                            <PaginationLink
                                                                onClick={e => handlePagination(e, pagination.page + 1)}
                                                                next
                                                                href="#" />
                                                        </PaginationItem>
                                                    </Pagination>
                                                </ErrorBoundary>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Modal size="lg" isOpen={modal.isVisible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setModal({ isVisible: false, data: { description: '', from: '', to: '', code: '', type: 'percentage', value: 0 } })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Data</span></ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleCouponSubmit}>
                        <FormGroup>
                            <Label for="from" style={theme.formBodyText} >From</Label>
                            <Input type="date" name="from" value={modal.data.from} onChange={handleChange} className="form-control" style={theme.formInput} required />
                        </FormGroup>

                        <FormGroup>
                            <Label for="to" style={theme.formBodyText} >To</Label>
                            <Input type="date" name="to" value={modal.data.to} onChange={handleChange} className="form-control" style={theme.formInput} required />
                        </FormGroup>

                        <FormGroup>
                            <Label for="code" style={theme.formBodyText} >Code</Label>
                            <InputGroup>
                                <Input type="text" name="code" value={modal.data.code} onChange={handleChange} className="form-control" style={theme.formInput} required />
                                <InputGroupAddon addonType="append" className="ml-2">
                                    <Button type="button" style={theme.formButton} onClick={generateCode}>Generate</Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </FormGroup>

                        <FormGroup>
                            <Label for="type" style={theme.formBodyText} >Type</Label>
                            <Input type="select" name="type" value={modal.data.type} defaultValue='percentage' onChange={handleChange} className="form-control" style={theme.formInput} required >
                                <option value='percentage'>Percentage</option>
                                <option value='value'>Value</option>
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label for="value" style={theme.formBodyText} >{modal.data.type === 'percentage' ? "Percentage" : "Value"}</Label>
                            <InputGroup>
                                {modal.data.type === 'percentage' ? [
                                    <Input type="number" min={0} max={100} name="value" value={modal.data.value} onChange={handleChange} className="form-control" style={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px' }} required />,
                                    <InputGroupAddon addonType="append">%</InputGroupAddon>
                                ] : [
                                    <InputGroupAddon addonType="prepend">₹</InputGroupAddon>,
                                    <Input type="number" min={0} name="value" value={modal.data.value} onChange={handleChange} className="form-control" style={{ borderTopRightRadius: '10px', borderBottomRightRadius: '10px' }} required />
                                ]}
                            </InputGroup>
                        </FormGroup>

                        <FormGroup>
                            <Label for={modal.data.type === 'percentage' ? "maxDiscount" : "minPurchaseRequired"} style={theme.formBodyText} >{modal.data.type === 'percentage' ? "Max Discount" : "Minimum Purchase Required"}</Label>
                            <InputGroup>
                                {modal.data.type === 'percentage' ? [
                                    <InputGroupAddon addonType="prepend">₹</InputGroupAddon>,
                                    <Input type="number" min={0} name="maxDiscount" value={modal.data.maxDiscount} onChange={handleChange} className="form-control" style={{ borderTopRightRadius: '10px', borderBottomRightRadius: '10px' }} required />
                                ] : [
                                    <InputGroupAddon addonType="prepend">₹</InputGroupAddon>,
                                    <Input type="number" min={0} name="minPurchaseRequired" value={modal.data.minPurchaseRequired} onChange={handleChange} className="form-control" style={{ borderTopRightRadius: '10px', borderBottomRightRadius: '10px' }} required />
                                ]}
                            </InputGroup>
                        </FormGroup>

                        <FormGroup>
                            <Label for="qty" style={theme.formBodyText} >Quantity</Label>
                            <Input type="number" name="qty" value={modal.data.qty} onChange={handleChange} className="form-control" style={theme.formInput} required />
                        </FormGroup>

                        <FormGroup>
                            <Label for="description" style={theme.formBodyText} >Description</Label>
                            <Input type="text" name="description" value={modal.data.description} onChange={handleChange} className="form-control" style={theme.formInput} required />
                        </FormGroup>

                        <Button type="submit" style={theme.formButton} disabled={isLoading2}>{isLoading2 ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Submit</Button>
                    </Form>
                </ModalBody>
            </Modal>
        </main>
    )

}

export default Coupons;